var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTwitter2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_88_11132",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2.5H21.5V21.5H2.5V2.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_88_11132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4625 3.39038H20.3763L14.0113 10.6837L21.5 20.6098H15.6371L11.0419 14.5909L5.78971 20.6098H2.87321L9.68064 12.8062L2.5 3.39174H8.51214L12.6596 8.89224L17.4625 3.39038ZM16.4379 18.8618H18.0529L7.63 5.04745H5.89829L16.4379 18.8618Z",
    fill: "#2A2B71"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitter2);
export default __webpack_public_path__ + "static/media/icon-twitter-2.49fc9c8a484f679b1df26ae74939965e.svg";
export { ForwardRef as ReactComponent };